<template>
<div id="upper" style="width:100%">
  <el-header class="headCss">
    <el-image
      style="width:8.8rem; height:3.25625rem;"
      :src="url"
      ></el-image>

    <div class="titleTab" :style="SBXH=='PC'?'width: 80%;':'width: 100%;'">

      <span :class="currentIndex=='1' ?'actived':''" @click="goPage('1')">首页</span>
      <span :class="currentIndex=='2' ?'actived':''" @click="goPage('2')">全部商品</span>
      <span :class="currentIndex=='3' ?'actived':''" @click="goPage('3')">赛事直播</span>
      <span :class="currentIndex=='4' ?'actived':''" @click="goPage('4')">合作健身房</span>
      <span :class="currentIndex=='6' ?'actived':''" @click="goPage('6')">商家合作</span>
<!--      <span :class="currentIndex=='5' ?'actived':''" @click="goPage('5')">关于我们</span>-->
      <el-input v-if="SBXH=='PC'"
              placeholder="请输入内容"
              v-model="searchText" style="width:30%">
        <i slot="prefix" class="el-input__icon el-icon-search" @click="searchGoods()"></i>
      </el-input>
<!--      <el-image  @click="goCarLst()"-->
<!--              style="width:22px; height:22px"-->
<!--              src="https://www.ystykj.com:9569/images/backstage-new/website/car.png"-->
<!--      ></el-image>-->
    </div>

<!--    <div style="display: flex;align-items: center">-->


<!--      <el-avatar v-if="SBXH=='PC'" src="https://www.ystykj.com:9569/images/backstage-new/website/tx.png" :size="22"></el-avatar>-->



<!--      <span v-if="SBXH=='PC'" style="color: #FF8F00;">欢迎您 </span>-->
<!--      <el-dropdown>-->
<!--        <i class="el-icon-caret-bottom" style="margin-right: 15px;color: #FF8F00;font-size: 12px;"></i>-->

<!--        &lt;!&ndash;        <i class="el-icon-caret-bottom" style="margin-right: 15px"></i>&ndash;&gt;-->
<!--        <el-dropdown-menu slot="dropdown">-->
<!--          <el-dropdown-item>修改个人资料</el-dropdown-item>-->
<!--          <el-dropdown-item>修改密码</el-dropdown-item>-->
<!--          <el-dropdown-item>注销账户</el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
<!--      <el-button type="small"  style=" border-radius:16px;color:#fff; background-color: #999;margin-left: 30px;">退出登录</el-button>-->
<!--    </div>-->
  </el-header>

</div>
</template>

<script>
import { getSBXH} from "../../api/common.js";

    export default {
        name: "upper",
      props:['currentIndex','searchText'],
        data() {
            return {
                activeIndex: '1',
                activeIndex2: '1',
                fits: ['fill'],
                url: this.$imgBaseUrl+'images/backstage-new/logoNew.png',
              // searchText:'',
              // currentIndex:'1',
              SBXH:'',
            };
        },
      created() {
          this.SBXH=getSBXH();

      },
      methods: {
          // goAllGoods(){
          //   this.$router.push('goods-all');
          //
          // },
          // goIndex(){
          //   this.$router.push('index');
          // }
          goPage(index){
            this.currentIndex=index;
            switch (index){
              case '2':
                this.$router.push('goods-all');
                break;
              case '3':
                this.$router.push('live-list');
                break;
              case '4':
                this.$router.push('gym');
                break;
              case '5':
                this.$router.push('us');
                break;
              case '6':
                this.$router.push('intro');
                break;
              default:
                this.$router.push('index');
                break;
            }
          },
          goCarLst(){
            this.$router.push('goods-car');
          },
          searchGoods(){
            this.$router.push({path:'search-list',query: {'keywords': this.searchText}});

          }
        }
    }
</script>

<style scoped>
.headCss{
  height:50px !important;
  text-align: right;
  width: 100%;
  box-shadow: rgb(242, 242, 242) 0px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}
  .el-icon-caret-bottom:hover{
    cursor:pointer;
  }
  .titleTab{
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    font-family: inherit;

  }
  .titleTab span:hover{
    cursor: pointer;
  color:#EF7C31;
  }
.titleTab span{
  padding-bottom: 15px;
  padding-top: 15px;
}
  .actived{
    color:#EF7C31;
    border-bottom: 3px solid #EF7C31;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/upper.vue